import React, { useContext, useMemo } from "react";
import {
  selected, multiple, smallFonts, colorsVariants,
  singleVariant, variantIsSelected, desktopVersion,
  mobileVersion, selectedVariantText, threeVariantsRow
} from "./style.mod.scss";
import ProductContext from "services/product-context";
import { Link } from "gatsby";
import getImagePath from "helpers/get-image-path";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import locale from "locales";

const isVariant = (cat) => cat._type === "productVariant";

const getFirstLeaf = (node) => {
  if (node.children.find(isVariant) !== undefined || node.children.length === 0) return node;

  return getFirstLeaf(node.children[0]);
};

const VariantCategoryLevel = (props) => {
  const { categories, variants, filteredProducts, currentVariant } = props;
  const { handle } = useContext(ProductContext);
  const isLeaf = useMemo(() => categories.find(isVariant) !== undefined, [categories]);
  if (isLeaf) return null;

  const selectedVariant = currentVariant?.handle?.current;
  const selectedVariantTitle = currentVariant?.category?.title;


  const children = categories.map((cat) => cat.children).flat().filter((cat) => cat !== undefined);
  const handleVariantChange = (cat) => {
    const leaf = getFirstLeaf(cat);

    const variant = variants.find((variant) => variant?.variantCategory?._ref === leaf?._id);

    return `/products/${handle}/${variant?.handle?.current}`;
  };

  const selectedClass = (cat) => cat.selected ? selected : "";
  const smallFontsClass = (cat) => cat?.smallFonts ? smallFonts : "";

  let parentSelected;
  let parentThreeVariants;

  let settings = {
    spaceBetween: 10,
    loop: false,
    dots: true,
    modules:[Pagination],
    autoHeight: false,
    pagination: { clickable: true },
    navigation: { clickable: true },
    breakpoints: {
      567: { spaceBetween: 20 },
      1200: {
        spaceBetween: 25,
        slidesPerView: 4.3,
      }
    }
  };

  return (
    <>
      {categories && categories.length > 0 && (
        <ul className={`${categories.length > 2 ? multiple : null}`}>
          {categories
            .filter((cat) => cat.selected || !cat.parent || (!cat.selected && cat.parent.selected))
            .map((cat) => {
              parentSelected = cat?.selected;
              parentThreeVariants = cat?.threeVariant;

              return (
                <li className={`${selectedClass(cat)} ${smallFontsClass(cat)}`} key={cat._id}>
                  <Link to={handleVariantChange(cat)} state={{ preserveScroll: true }} role="button">
                    {cat.icon && <img srcSet={getImagePath(cat?.icon, true)} alt={cat?.icon?.alt} />}
                    <span>{cat.title}</span>
                  </Link>
                </li>
              );
            })}
        </ul>
      )}
      {!isLeaf && children.length !== 0 &&
        <>
          <div className={`${colorsVariants} ${desktopVersion} ${(parentSelected && parentThreeVariants) && threeVariantsRow}`}>
            {filteredProducts?.map((variant, i) => {
              return (
                <div key={i} className={`${singleVariant} 
                ${(variant?.handle?.current == selectedVariant) && variantIsSelected} `}>
                  <Link to={`/products/${handle}/${variant?.handle?.current}`} state={{ preserveScroll: true }} role="button">
                    <img srcSet={getImagePath(variant?.variantIcon)} alt={variant?.variantIcon?.alt} />
                  </Link>
                </div>
              );
            })}
          </div>
          <div className={`${colorsVariants} ${mobileVersion}`}>
            <Swiper {...settings}     
              slidesPerView= {(parentSelected && parentThreeVariants) ? 2.5 : 3.5} 
              className={`${(parentSelected && parentThreeVariants) && threeVariantsRow}`}>
              {filteredProducts?.map((variant, i) => {
                return (
                  <SwiperSlide key={i} >
                    <div className={`${singleVariant} ${(variant?.handle?.current == selectedVariant) && variantIsSelected}`}>
                      <Link to={`/products/${handle}/${variant?.handle?.current}`} state={{ preserveScroll: true }} role="button">
                        <img srcSet={getImagePath(variant?.variantIcon)} alt={variant?.variantIcon?.alt} />
                      </Link>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
          <p className={selectedVariantText}>{locale?.products?.size}: <strong>{selectedVariantTitle}</strong></p>
        </>
      }
    </>
  );
};

export default VariantCategoryLevel;